import React from 'react';

export default function BalanceTable({ data: { headings, body } }) {
    const renderHeadings = () => {
        let headingsTemplate;

        headingsTemplate = headings.map((item, _index) => <th key={_index}>{item}</th>);

        return headingsTemplate;
    };

    const renderRow = (_row, rowIndex) => (
        <tr key={rowIndex} align='center'>
            {body[rowIndex].map((_cell, cellIndex) => (
                <td key={cellIndex}>{_cell}</td>
            ))}
        </tr>
    );

    const tbodyMarkup = body.map(renderRow);

    return (
        <table className={'point-table point-table--balance'}>
            <thead className='balance-heading'>
                <tr align='center'>{renderHeadings()}</tr>
            </thead>
            <tbody className='balance-body'>{tbodyMarkup}</tbody>
        </table>
    );
}
